import { apiV2, errorHandler } from "./index";
import { API_ERROR, FETCH_AUTHORS, FETCH_ONE_AUTHOR, CLEAR_AUTHORS } from "../constants/ActionTypes";
import Swal from "sweetalert2";

//= ===============================
// Client actions
//= ===============================

export function fetchAuthors() {
  return function (dispatch) {
    return apiV2
      .get(`/authors`)
      .then(response => {
        dispatch({
          type: FETCH_AUTHORS,
          payload: response.data.objects,
        });
        return response;
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

export function fetchOneAuthor(authorId) {
  return function (dispatch) {
    return apiV2
      .get(`/authors/${authorId}`)
      .then(response => {
        dispatch({
          type: FETCH_ONE_AUTHOR,
          payload: response.data,
        });
        return response;
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

export function addEditAuthor(author_json, onSuccess) {
  return function (dispatch) {
    const data = typeof author_json === 'string' ? JSON.parse(author_json) : author_json;
    const request = data.author_id
      ? apiV2.put(`/authors/${data.author_id}`, data)
      : apiV2.post('/authors', data);

    request
      .then(response => {
        Swal.fire({
          icon: "success",
          title: "Saved!",
          timer: 1000,
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function deleteAuthor(author_id, onSuccess) {
  return function (dispatch) {
    apiV2
      .delete(`/authors/${author_id}`)
      .then(response => {
        Swal.fire({
          icon: "success",
          title: "Author Deleted!",
          timer: 1000,
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function clearAuthors(page) {
  return function (dispatch) {
    dispatch({
      type: CLEAR_AUTHORS,
    });
  };
}
